module.exports = __webpack_public_path__ + "img/oooh.b0bdb6ad.png";